<template>
  <div class="midAutumn"
    :style="{
      backgroundImage: 'url(' + pageConfig.img + ')',
      backgroundColor: pageConfig.bgcolor
    }"
  >
    <div class="tit tit1"
    :style="{
      backgroundImage: 'url(' + tit1.img + ')',
    }"
    ></div>
    <div
      :key="i"
      class="giftsList"
      v-for="(columns, i) in worthBuyingTodayGoods"
    >
      <swipe
        :autoplay="3000"
        :ref="'worthSwiper' + i"
        @change="swipeChange"
        class="worth-buying-today-swiper"
        indicator-color="#FF5555"
        v-if="i == currentTodayNavIndex"
        :width="itemWidth"
      >
        <swipe-item
          :key="index"
          v-for="(skus, index) in columns.sku_list"
        >
         <!-- @click="columnSortJump(sku.item_id, sku.sku_id, sku.platform, sku.item_type)" -->
          <div class="tab-content">
            <a
              :key="index"
              @click="columnSortJump(columns, sku.item_id, sku.sku_id)"
              class="goods-details"
              href="javascript:;"
              v-for="(sku, index) in skus"
            >
              <div class="goods-img van-hairline--surround">
                <img alt v-lazy="sku.pic_url" />
              </div>
              <div class="goods-intro">
                <div class="goods-price">
                  ¥<em>{{sku.activity | salePrice(sku.equity, sku.market_price)}}</em>
                </div>
                <div class="normal-price">
                  <del>¥{{ sku.market_price }}</del>
                </div>
              </div>
            </a>
          </div>
        </swipe-item>
        <template #indicator>
          <div class="custom-indicator" style="display :none;">
            <div
              :class="{ 'current-item': index == currentSwipe.current }"
              :key="index"
              class="indicator-item"
              v-for="(skus, index) in columns.sku_list"
            ></div>
          </div>
        </template>
      </swipe>
    </div>
    <div class="tit tit2"
    :style="{
      backgroundImage: 'url(' + tit2.img + ')',
    }"
    ></div>
    <div class="goodsList">
      <FooterColumn
        :column-config="localSelectData"
        v-if="loadLocalStatus"
      />
    </div>
  </div>
</template>

<script>
import api from '../../utils/api'
import { arrayHandle } from '../../utils/common'
import FooterColumn from '../../components/HomeColumnGoods'
import { Swipe, SwipeItem } from 'vant'
// let flag = false
export default {
  name: 'midAutumn',
  components: {
    Swipe,
    SwipeItem,

    FooterColumn
  },
  data () {
    return {
      pageConfig: { img: '', bgcolor: '' },
      tit1: { img: '' },
      tit2: { img: '' },
      worthBuyingTodayGoods: [],
      currentTodayNavIndex: 0,
      localSelectData: {},
      loadLocalStatus: false,
      currentSwipes: [{
        current: 0
      }]
    }
  },
  computed: {
    currentSwipe () {
      return this.currentSwipes[this.currentTodayNavIndex]
    },
    itemWidth () {
      return (document.documentElement.clientWidth || document.body.clientWidth) / 156 * 36
    }
  },
  filters: {
    // 价格展示
    salePrice (activity, member, market) {
      if (activity) {
        return activity.discount
      } else if (member) {
        return member.discount
      } else {
        return market
      }
    }
  },
  created () {
    this.$toast.loading('正在加载,请稍后...')
    this.getVersionJSON()
  },
  methods: {
  // 获取首页数据
    async getVersionJSON () {
      const data = await api.getJsonVersion('activity').catch((err) => {
        this.$toast.clear()
        throw Error(err)
      })
      this.$toast.clear()
      this.loadLocalStatus = true
      const p1 = data['activity-1'].data || []
      this.pageConfig = p1[0] || { img: '', bgcolor: '' }
      const p2 = data['activity-2-c'].data || []
      this.tit1 = p2[0] || { img: '' }
      const p3 = data['activity-3-c'].data || []
      this.tit2 = p3[0] || { img: '' }
      const p4 = data['activity-2'].data || []
      this.worthBuyingTodayGoods = p4.map((v, i) => {
        this.currentSwipes.push({ current: 0 })
        v.sku_list = v.sku_list.length && arrayHandle(v.sku_list.length > 9 ? v.sku_list.slice(0, 9) : v.sku_list, 1)
        return v
      })
      const p5 = data['activity-3']
      this.localSelectData = p5 && p5.data.length && p5.data[0]
    },
    // 轮播切换
    swipeChange (i) {
      this.currentSwipes[this.currentTodayNavIndex].current = i
    },
    // 栏目商品排序跳转
    async columnSortJump (configer, gid, sid) {
      await api.homeConfigJump(configer, gid, sid)
      console.log(configer, gid, sid)
    }
    // async columnSortJump (goodsid, skuid, platform, type) {
    //   if (flag) {
    //     return false
    //   }
    //   flag = true
    //   await api.routeJump({ goodsid, skuid, platform, type })
    //   flag = false
    // }
  }
}
</script>

<style lang="less" scoped>
.midAutumn {
  font-family: PingFangSC, PingFangSC-Medium;
  background-repeat: no-repeat;
  background-size:100%;
  min-height: 100vh;
  padding: 6.84rem 0 .35rem;
  box-sizing: border-box;
  .tit{
    width: 5.63rem;
    height: .86rem;
    background-repeat: no-repeat;
    background-size:100%;
    margin: 0 auto .25rem;
  }
  .giftsList {
    width: 7.02rem;
    height: 3.2rem;
    padding-top: .35rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.14rem;
    margin: 0 auto .39rem;
    overflow: hidden;
    .tab-content {
      // .flex-between-wrap;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
    .goods-details {
      width: 100%;
      margin-bottom: 0.3rem;
      .flex-column-center;
      // &:nth-child(3n-1) {
      //   margin: 0 0.2rem;
      // }
    }
    .goods-intro {
      width: 1.4rem;
    }
    .goods-img {
      width: 1.6rem;
      height: 1.6rem;
      margin-bottom: .22rem;
      img {
        object-fit: contain;
      }
    }
    .goods-name {
      font-size: @fz26;
      color: @base;
      margin: 0.15rem 0;
      font-weight: 500;
    }
    .goods-price {
      color: #ff7845;
      font-size: @fz24;
      em {
        font-size: @fz26;
      }
    }
    .store-name {
      color: #848484;
      font-size: @fz22;
      padding-top: 0.1rem;
    }
    .goods-intro {
      .goods-price {
        color:rgba(188, 118, 80, 1);
        padding-bottom: 0.03rem;
      }
      .normal-price {
        color: #98999c;
        font-size: @fz22;
        padding-bottom: 0.1rem;
        transform: scale(.95);
        margin-left: -.025rem;
      }
    }
    .custom-indicator {
      position: absolute;
      bottom: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      .indicator-item {
        width: 0.1rem;
        height: 0.06rem;
        background-color: #ebebeb;
        margin-left: 0.05rem;
      }
      .current-item {
        width: 0.3rem;
        background-color: #ff5555;
      }
    }
  }
  .goodsList{
    /deep/ .discount-num{
      background: linear-gradient(136deg,#674d3d 1%, #3a2d21 98%);
      border-radius: 0px 100px 100px 8px;
    }
  }
}
</style>
